"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _stores = require("@seedlang/stores");
var _mobx = require("mobx");
var _privacy_settings_state = _interopRequireDefault(require("./privacy_settings_state"));
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var SEEDLANG_BANNER_VISIBLE_ON_ROUTE_NAMES = ['landing'];
var PrivacySettingsUI = (_class = /*#__PURE__*/function (_RootState) {
  function PrivacySettingsUI() {
    var _this;
    _classCallCheck(this, PrivacySettingsUI);
    _this = _callSuper(this, PrivacySettingsUI);
    _initializerDefineProperty(_this, "isModalVisible", _descriptor, _this);
    _this.acceptAll = function () {
      _privacy_settings_state["default"].acceptAll();
      _privacy_settings_state["default"].saveChoices();
    };
    _this.rejectAll = function () {
      _privacy_settings_state["default"].rejectAll();
      _privacy_settings_state["default"].saveChoices();
    };
    _initializerDefineProperty(_this, "showModal", _descriptor2, _this);
    _initializerDefineProperty(_this, "hideModal", _descriptor3, _this);
    return _this;
  }
  _inherits(PrivacySettingsUI, _RootState);
  return _createClass(PrivacySettingsUI, [{
    key: "user",
    get: function get() {
      return _stores.AuthUserStore.showData;
    }
  }, {
    key: "site",
    get: function get() {
      var _this$user;
      return (_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.site;
    }
  }, {
    key: "routeStore",
    get: function get() {
      return _stores.RouteStore;
    }
  }, {
    key: "isBannerVisible",
    get: function get() {
      var _this$site;
      if (!((_this$site = this.site) !== null && _this$site !== void 0 && _this$site.id)) return false;
      if (this.hide) return false;
      if (_privacy_settings_state["default"].isComplete && !this.isModalVisible) return false;
      var routeName = this.routeStore.routeName;
      if (this.site.isSeedlang) {
        return SEEDLANG_BANNER_VISIBLE_ON_ROUTE_NAMES.includes(routeName);
      }
      return !(routeName !== null && routeName !== void 0 && routeName.startsWith('onboarding'));
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "isModalVisible", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isBannerVisible", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBannerVisible"), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showModal", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function () {
      _this2.isModalVisible = true;
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hideModal", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function () {
      _this3.isModalVisible = false;
    };
  }
}), _class);
var _default = exports["default"] = new PrivacySettingsUI();